<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <div>
                Tipo Actividad<select class="form-control" v-model="configuration.TIPO_ACTIVIDAD" @change="updateSeriesActivity">
                  <option value="0">Serie numérica</option>
                  <option value="1">Comparación</option>
                  <option value="2">Ordenar</option>
                </select>
              </div>
          </div>
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Representaciones</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ESCRITO"
                id="VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal escrito</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" disabled
                  id="REPRESENTACION_GRAFICA" v-model="configuration.REPRESENTACION_GRAFICA">
                <label class="custom-control-label" for="REPRESENTACION_GRAFICA">Representación Gráfica</label>
              </div>
              <br/>
               <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                  id="TRATA_RAZON" v-model="configuration.TRATA_RAZON">
                <label class="custom-control-label" for="TRATA_RAZON">Tratamiento en Razón</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Tipo Ordinal</div>
              <div>
                Singular<select class="form-control" v-model="configuration.SINGULAR">
                  <option value="0">Primero, tercero</option>
                  <option value="1">Primer, tercer</option>
                </select>
              </div>
              <br/>
              <div>
                Decena<select class="form-control" v-model="configuration.DECENA">
                  <option value="0">Décimo primero...</option>
                  <option value="1">Undécimo...</option>
                </select>
              </div>
              <!--Tipo Representación<select class="form-control" v-model="configuration.TIPO_REPRESENTACION">
                    <option value="0">Esferas</option>
                    <option value="1">Imágenes</option>
                    <option value="2">Abaco</option>
                  </select>
              <br>
                  Posición de Representación<select class="form-control" v-model="configuration.POSICION_REPRESENTACION">
                    <option value="-1">Sin posicionamiento</option>
                    <option value="0">Base 10 con resalte</option>
                    <option value="1">Base 10 sin resalte</option>
                    <option value="2">Optimizado ordenado</option>
                    <option value="3">Optimizado aleatorio</option>
                  </select>
              <br>-->
            </div>
      </div>
      <br>
      <hr>
      <b-row class="text-center mb-3">
        <b-col>
          <strong>Series del ejercicio</strong>
          <button @click="addArrayEleOperation()" class="btn btn-primary btn-sm ml-3" v-if="!bShowSequenceExercise">
            Añadir
          </button>
        </b-col>
      </b-row>
      <div v-if="bShowSequenceExercise">
        <b-row v-if="configuration.TIPO_ACTIVIDAD !== '1'">
          <b-col  style="text-align:center">
            <strong>Operaciones del ejercicio</strong>
            <b-button v-if="arrayElementSequence.length > 3" @click="removeArraySequence()" class="btn btn-danger ml-2" size="sm">-</b-button>
            <b-button @click="addArraySequence()" class="btn btn-primary ml-2" size="sm">+</b-button>
          </b-col>
        </b-row>
        <br>
        <div>
          <div v-for="(operation, index) in arrayElementSequence" v-bind:key="index">
              <b-row class="justify-content-center align-items-center" style="margin-bottom: 10px">
                  <b-col col lg="4">
                    <ValidationProvider
                      :rules="{
                          required: true,
                          seqvalue: (index % 2 !== 0) ? true : false}"
                      v-slot="{ errors }">
                      <b-form-input type="text"
                          :placeholder="index % 2 === 0 ? 'Valor' : 'Razón'"
                          v-bind:id="'VALOR' + index"
                          v-model="arrayElementSequence[index].VALOR"/>
                      <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col col lg="3">
                    <input type="checkbox"
                      v-model="arrayElementSequence[index].VISIBLE"><span class="pl-1 pr-4">Visible</span>
                    <input type="checkbox"
                      v-model="arrayElementSequence[index].INCOGNITA"><span class="pl-1">Incógnita</span>
                  </b-col>
              </b-row>
          </div>
        </div>
        <br>
        <b-row>
          <b-col class="text-center">
            <button @click="saveSequence(idEleOperationEdit)" class="btn btn-info btn-sm">Aceptar</button>
            <button @click="clearSequence()" class="btn btn-danger btn-sm">Cancelar</button>
          </b-col>
        </b-row>
      </div>
      <hr />
      <b-row class="align-items-center">
        <b-col lg="12">
          <b-row v-for="(element, indexEle) in arrayEleOperation" v-bind:key="indexEle" style="margin-top:10px">
            <b-col lg="1" v-if="!bShowSequenceExercise">
              <button class="btn btn-info" @click="editSequence(indexEle)"><i class="zmdi zmdi-edit"/></button>
              <button class="btn btn-danger" @click="removeArrayEleOperation(indexEle)"><i class="fa fa-trash"/></button>
            </b-col>
            <b-col class="boxsequence" v-for="sequence in element.ELEMENTSEQUENCE" v-bind:key="sequence.POSICION" style="text-align:center">
              <span v-text="sequence.VALOR" class="sequenceNumber"></span>
              <br>
              <i class="fa-lg" :class="sequence.VISIBLE ? 'fa fa-eye text-info' : 'fa fa-eye-slash text-muted'"
                :title="sequence.VISIBLE ? 'Visible' : 'Oculto'" />
              &nbsp;
              <i class="fa-lg" :class="sequence.INCOGNITA ? 'fa fa-question-circle text-info' : 'fa fa-question text-muted'"
                :title="sequence.INCOGNITA ? 'Incógnita' : 'Activo'" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top:25px">
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="bShowSequenceExercise || arrayEleOperation.length < 1" class="btn btn-info btn-lg">
            Guardar
          </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import seriesMixin from '../../../../mixins/series';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
extend('seqvalue', {
  validate(value) {
    const arrayValid = ['<', '>', 'MT', 'LT', '!=', '=', 'E', 'EQUIVALENTE', 'D', 'DIVISOR', 'V', 'DIVISIBLE', 'B', 'DOBLE', 'M', 'MULTIPLO'];
    const valid = arrayValid.indexOf(value.toUpperCase()) >= 0;
    const number = /^([+-](?=\.?\d))?(\d+)?(\.\d+)?$/.test(value);
    return valid || number;
  },
  message: 'Número o valores: < o LT, > o MT, E, D, V, B, M, !=, =,',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, seriesMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      bShowSequenceExercise: false,
      bNewSequence: false,
      arrayEleOperation: [],
      idEleOperationEdit: -1,
      arrayElementSequence: [], // Sequence editing on screen
      // Mapear con los campos de la tabla SERIESORDINALES_CONF
      configuration: {
        ID: -1,
        SINGULAR: 0,
        DECENA: 0,
        TIPO_ACTIVIDAD: 0,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: false,
        REPRESENTACION_GRAFICA: false,
        TIPO_REPRESENTACION: 0,
        IMAGENES_ID: 0,
        POSICION_REPRESENTACION: 0,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID, 'ordinalsequence/getordinalsequence');
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
<style>
  .sequenceNumber{
    font-weight: bold;
    font-size: 1.2rem !important;
  }
  .enable {
    background-color:rgb(8, 66, 33);
    color: white;
    padding: 3px
  }
  .disabled {
    background-color: rgb(207, 207, 207);
    padding: 3px;
  }
  .boxsequence {
    border-color: rgba(139, 223, 29, 0.3);
    border: 1px solid;
    padding: 5px;
  }
</style>
